<div
  class="filter-container"
  [class.has-results]="searchString()">
  <h2>{{ 'search.results.filter-title' | translate }}</h2>
  <div class="filter-list">
    @for (searchResultGroup of searchResultGroups(); track searchResultGroup) {
      <coin-v2-button
        type="secondary"
        [icon]="searchResultGroup.icon"
        [svgIcon]="searchResultGroup.svgIcon"
        [text]="searchResultGroup.titleKey | translate"
        [attr.aria-label]="
          (isFilterActive(searchResultGroup.resultType)
            ? searchResultGroup.hideResultsDescriptionKey
            : searchResultGroup.showResultsDescriptionKey
          ) | translate
        "
        [class.selected]="isFilterActive(searchResultGroup.resultType)"
        (click)="toggleFilter(searchResultGroup.resultType)"></coin-v2-button>
    }
  </div>
</div>

@if (searchString()) {
  <div>
    @for (searchResultGroup of searchResultGroups(); track searchResultGroup) {
      @if (showSearchResults(searchResultGroup.resultType)) {
        <div class="search-group">
          <h3>
            {{ searchResultGroup.titleKey | translate }}
            {{
              ((searchResultGroup.isLoading$ | async) === false && searchResultGroup.hasResults$ | async)
                ? '(' + (searchResultGroup.resultsCountDisplayString$ | async) + ')'
                : ''
            }}
          </h3>

          @if ((searchResultGroup.hasResults$ | async) === false && (searchResultGroup.isLoading$ | async) === false) {
            <p class="bold">
              {{ searchResultGroup.noResultsMessageKey | translate }}
            </p>
          }

          @if (searchResultGroup.hasResults$ | async) {
            <ul>
              @for (result of searchResultGroup.results$ | async; track result) {
                <li>
                  <a
                    #searchResult
                    [name]="searchResultGroup.titleKey"
                    (click)="navigateToResult(result, true, 'department-view')">
                    <p [innerHTML]="result.displayName | highlight: searchString()"></p>
                    <ng-container *coinFeatureFlag="'inCompanyView'">
                      @if (searchResultGroup.resultType === 'people') {
                        <p
                          class="alternative-link"
                          (click)="$event.stopPropagation(); navigateToResult(result, true, 'in-company-view')">
                          {{ 'search.results.view-in-company' | translate }}
                        </p>
                      }
                    </ng-container>
                  </a>
                </li>
              }
            </ul>
          }

          @if (searchResultGroup.isLoading$ | async) {
            <app-loading-screen
              [contrast]="true"
              [local]="true"></app-loading-screen>
          }

          @if (searchResultGroup.hasMoreResults$ | async) {
            <button
              class="no-style show-more"
              (click)="loadMoreResults(searchResultGroup.resultType)">
              {{ 'search.results.show-more' | translate }}
            </button>
          }
        </div>
      }
    }
  </div>
} @else {
  @if (resultCacheKey() && (recentSearchResults$ | async)?.length > 0) {
    <div class="search-group">
      <h3>{{ 'search.results.recent' | translate }}</h3>

      <ul>
        @for (result of recentSearchResults$ | async; track result) {
          <li>
            <a (click)="navigateToResult(result, false, 'department-view')">
              <p [innerHTML]="result.displayName"></p>
              <ng-container *coinFeatureFlag="'inCompanyView'">
                @if (result.resultType === 'people') {
                  <p
                    class="alternative-link"
                    (click)="$event.stopPropagation(); navigateToResult(result, true, 'in-company-view')">
                    {{ 'search.results.view-in-company' | translate }}
                  </p>
                }
              </ng-container>
            </a>
          </li>
        }
      </ul>
    </div>
  }
}

<ng-template #recentSearchResults>
  @if (resultCacheKey() && (recentSearchResults$ | async)?.length > 0) {
    <div class="search-group">
      <h3>{{ 'search.results.recent' | translate }}</h3>

      <ul>
        @for (result of recentSearchResults$ | async; track result) {
          <li>
            <a (click)="navigateToResult(result, false)"><p [innerHTML]="result.displayName"></p></a>
          </li>
        }
      </ul>
    </div>
  }
</ng-template>
